// eslint-disable-next-line import/no-anonymous-default-export
export default {
  USER_ID: "user_9LvDgXfdZLXUCssd2jjnf",
  TEMPLATE_ID: "template_ho4gcfq",
  TEMPLATE_LLAMADA: "template_0j4fsiu",
};
